import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api, { setCenterId, getCenterId } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CenterContext = createContext(null);

export function CenterProvider({ children }) {
  const { user } = useAuth();
  const [centers, setCenters] = useState(null);
  const [activeId, setActiveId] = useState(getCenterId());

  const load = useCallback(async () => {
    const { data } = await api.get("/centers");
    setCenters(data);
    let current = getCenterId();
    if (!current || !data.find((c) => c.id === current)) {
      current = data[0]?.id || null;
      setCenterId(current);
      setActiveId(current);
    } else {
      setActiveId(current);
    }
    return data;
  }, []);

  useEffect(() => { if (user) load(); }, [user, load]);

  const switchCenter = (id) => {
    setCenterId(id);
    setActiveId(id);
  };

  const activeCenter = centers?.find((c) => c.id === activeId) || null;
  const role = user?.is_super_admin ? "admin" : (activeCenter?.my_role || "employee");
  const isManager = role === "admin" || role === "supervisor";
  const isSuperAdmin = !!user?.is_super_admin;

  return (
    <CenterContext.Provider value={{ centers, activeId, activeCenter, role, isManager, isSuperAdmin, switchCenter, reload: load }}>
      {children}
    </CenterContext.Provider>
  );
}

export const useCenter = () => useContext(CenterContext);
